import * as React from 'react';
import { ICoherenceHeaderProps } from '@coherence-design-system/controls/lib/header';

export function useHeaderConfig(): ICoherenceHeaderProps {
  return {
    headerLabel: __APP_NAME__,
    appNameSettings: {
      label: __APP_NAME__,
    },
  };
}
